export default __webpack_public_path__ + "static/media/downarrow.284c45ac.svg";